import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
import handleObject from '@/src/utils/handle-objects'
import { formatUrl } from "@utils/formatUrl";

let serverUrl = getSecret('SERVER_AUTH_URL')

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_COMPANY_INFO(state, companyInfo) {
    state.cached = companyInfo
  },
}

export const actions = {
  init({ state, dispatch }) {},

  fetchCompanyInfo(context, query) {
    query = query || ''
    return axios
      .get(`${serverUrl}/api/company-info/${query}`)
      .then((response) => {

        const results = handleObject.changeValue(response.data.results)
        if (results.length) {
          let compInfo = results[results.length - 1]
          let newci = handleObject.changeUrlValue(compInfo,"/media/", "/cciudadano/autenticacionms/media/")
          compInfo = newci
          context.commit('CACHE_COMPANY_INFO', compInfo)
          return compInfo
        } else {
          return {}
        }
      })
  },

  createUpdateCompanyInfo(context, formData) {
    let promise = null
    if (formData.url) {
      promise = axios.put(formatUrl(formData.url), formData)
    } else {
      promise = axios.post(`${serverUrl}/api/company-info/`, formData)
    }
    return promise.then((response) => {
      return response.data
    })
  },

  setFileCompanyInfo(context, { url, formData }) {
    let promise = null
    promise = axios.put(`${url}set_file/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return promise.then((response) => {
      return response.data
    })
  },
}
